import React, { useEffect, useState } from 'react'
import { useModel, useSelector } from 'umi'
import styles from './index.scss'
import { Button, Popup, Modal } from 'antd-mobile'
import Layout from '@/libs/components/Layout'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper'
import { IconExpand, IconCollapse } from './svg'
import goTo from '@/libs/functions/goTo'
import ActivityZoneList from '@/libs/components/ActivityZoneList'
import OauthAfterPageMask from '@/libs/components/OauthAfterPageMask'
import { goToEquityUrl, hex2Rgb } from '@/libs/functions/tools'
import moment from 'moment'
import { addParameter } from '@/libs/functions/tools'
import { getToken } from '@/libs/functions/getValue'
import { checkUserLogin } from '@/services'
import NoticeLayout from '@/libs/components/noticeListLayout'

type TemplateConfigType = {
  preTitle: string // 专区页面标题
  lvTitle: string // 等级权益标题
  btnText: string // 专区页面按钮文案
  exchangeRules: string //兑换规则
  listStyle: 1 | 2 // 权益列表样式 1:列表式 2:卡片式
  openGroup: boolean // 是否分组展示权益 true:开 false:关
  orderUrl: string // 历史订单地址
  showOrder: boolean // 是否展示历史订单
  showPersonal: boolean // 是否展示个人中心
  headerSnippets: string[]
}

const equityGoods = () => {
  let { baseInfo = {} } = useSelector((state: any) => state.LevelZone) || {}
  const [isExpand, setExpand] = useState(false)
  const [sourceChannel, setSourceChannel] = useState('')
  const [terms, setTerms] = useState({ visible: false })
  // const []

  const {
    levelCode,
    levelEquityListResps = [],
    showAllLevel,
    levelStatus,
    protocolList,
  } = baseInfo
  const CurrentLevelRes =
    levelEquityListResps.find((item) => item.levelCode === levelCode) || {}

  const {
    backGroundColor,
    backGroundImage,
    fontColor,
    backGroundType,
    themeColor,
    pageBackGroundColor,
    buttonBgColorStyle,
    buttonBgColor,
    buttonBgColor2,
    buttonTextColor,
    titleColor,
    moduleBackground,
    textColor,
    topBanner,
    levelName,
    levelDesc,
    memberMobile,
    levelExpirationEnd,
    equityCategoryRespList,
    levelEquityGroupRespList,
    productCategoryRespList,
    levelProductGroupRespList,
    totalCommonUerPoint,
    enableSection,
    sectionTitle,
    banners = [],
    activates = [],
    on,
    memberName,
    levelProducts,
  } = CurrentLevelRes || {}

  const templateConfig: TemplateConfigType = CurrentLevelRes.templateConfig
    ? JSON.parse(CurrentLevelRes.templateConfig)
    : {}
  const settingConf: TemplateConfigType = CurrentLevelRes.settingConf
    ? JSON.parse(CurrentLevelRes.settingConf)
    : {}
  const {
    lvTitle,
    lvDesc,
    showOrder,
    needFilterOrder,
    orderBtnText,
    showBottomTip,
    bottomTipText,
    bottomBackgroundColor,
    showCustomerService,
    customerServiceUrl,
    customerServiceText,
    customerServiceIcon,
  } = templateConfig
  const {
    headerSnippets,
    bannerTitle,
    listBackgroundImage,
    enableProduct,
    productTitle,
    productDesc,
  } = settingConf
  const showMobile = (headerSnippets ?? []).includes('phone')
  const showUserName = (headerSnippets ?? []).includes('userName')
  const showExpiration = (headerSnippets ?? []).includes('expiration')
  const showMemberLabel = (headerSnippets ?? []).includes('memberLabel')

  let equityList = templateConfig.openGroup
    ? levelEquityGroupRespList || []
    : [
        {
          groupName: '',
          equityCategoryRespList: equityCategoryRespList || [],
        },
      ]

  const equityListAll =
    (templateConfig.openGroup
      ? levelEquityGroupRespList?.map((levelGroupItem) =>
          levelGroupItem.relateType === 'group'
            ? levelGroupItem
            : { ...levelGroupItem.equityCategoryRespList?.[0] },
        )
      : equityCategoryRespList) || []

  console.log(equityListAll)

  // const equityListAll =
  //   equityList?.map?.((item) => item.equityCategoryRespList).flat() || []
  // console.log(equityListAll)

  SwiperCore.use([Navigation, Pagination, Autoplay])

  const styleConfig: any = {
    '--member-bg-color': pageBackGroundColor,
    '--member-primary-color': themeColor,
    '--member-primary-color-rgb': hex2Rgb(themeColor),
    '--member-card-bg-color':
      Number(backGroundType) === 1
        ? backGroundColor
        : `url(${backGroundImage}) no-repeat`,
    '--member-card-title-color': fontColor,
    '--member-btn-bg-color': buttonBgColor || themeColor,
    '--member-btn-bg-color2':
      buttonBgColorStyle === 'gradient'
        ? buttonBgColor2
        : buttonBgColor || themeColor,
    '--member-btn-text-color': buttonTextColor || '#fff',
    '--member-title-color': titleColor || '#fff',
    '--member-module-bg-color': moduleBackground || '#fff',
    '--member-text-color': textColor || '#fff',
    '--member-top-banner': `url(${topBanner}) no-repeat`,
    '--member-footer-bg-color': bottomBackgroundColor,
    '--member-card-wrap-bg': `url(${topBanner || ''}) no-repeat`,
  }
  const style = { '--font-color': textColor || '#222222', ...styleConfig }
  useEffect(() => {
    const _sourceChannel =
      levelName && levelCode ? `${levelName}(${levelCode})` : ''
    // console.log('_sourceChannel', _sourceChannel)
    sessionStorage.setItem('sourceChannel', _sourceChannel)
    setSourceChannel(_sourceChannel)
  }, [levelName, levelCode])

  const onGoToService = async (customerServiceUrl?: string) => {
    if (!customerServiceUrl) return
    await checkUserLogin()
    goTo(addParameter(customerServiceUrl, 'clientToken', getToken('h5Token')))
  }

  const onOpenGroup = (equity: Record<string, any>) => {
    Modal.show({
      style: {
        '--max-width': '84%',
        '--min-width': '84%',
        ...styleConfig,
      },
      className: styles['equity-group-modal'],
      title: '请使用权益',
      content: (
        <div key="group" className={styles['equity-group']}>
          {equity?.equityCategoryRespList?.map((item) => (
            <div
              className={styles['equity-group-item']}
              onClick={() => {
                Modal.clear()
                // goTo(item.equityCouponUrl)
                goToEquityUrl({
                  equityCouponCode: equity.equityCouponCode,
                  categoryType: equity.categoryType,
                })
              }}
            >
              <img
                className={styles.image}
                src={
                  item?.iconUrl ||
                  'https://oss-images.dragonpass.com.cn/business-saas/platform/2025-03-14_175917/%E7%A9%BA%E7%8A%B6%E6%80%81%E5%9B%BE%E6%A0%87.png'
                }
              />
              <div className={styles.content}>
                <div className={styles.title}>{item?.relationDesc}</div>
                <div className={styles.desc}>
                  {item?.availableEquityNumName || ''}
                  {item?.equityUnitName || ''}
                </div>
              </div>
              <div className={styles.btn}>立即使用</div>
            </div>
          ))}
        </div>
      ),
      showCloseButton: true,
    })
  }

  const levelStatusName =
    levelStatus === 'expired'
      ? '已过期'
      : levelStatus === 'invalid'
      ? '已作废'
      : ''

  const noticeStyle = {
    '--header-bg-color-rgb': hex2Rgb(themeColor),
    '--title-color': textColor,
    '--content-color': textColor || '#fff',
    '--content-bg-color': pageBackGroundColor || moduleBackground || '#fff',
    '--btn-bg-color': buttonBgColor || themeColor,
    '--btn-bg-color2':
      buttonBgColorStyle === 'gradient'
        ? buttonBgColor2
        : buttonBgColor || themeColor,
    '--btn-color': buttonTextColor || '#fff',
  }

  return (
    <Layout title={templateConfig.preTitle}>
      <div
        style={{
          background: pageBackGroundColor,
          height: '100%',
        }}
      >
        <NoticeLayout
          isReadyToShowNotice={!!levelCode}
          sectionCode={levelCode}
          style={noticeStyle}
        >
          {({ isShowRollNotice = false }) => (
            <OauthAfterPageMask
              triggerNodeCode={levelCode}
              triggerNode="section"
              redirect={window.location.hash.replace('#', '')}
            >
              <div
                className={styles['level-wrap']}
                style={{
                  ...style,
                  top: isShowRollNotice ? '10.167vw' : 0,
                }}
                // style={{
                //   ...style,
                //   top: isShowRollNotice
                //     ? '10.167vw' // 40px
                //     : 0,
                // }}
              >
                <div className={styles['level-card']}>
                  {!!levelStatusName && (
                    <div className={styles['level-status']}>
                      {levelStatusName}
                    </div>
                  )}
                  {backGroundType == 1 ? (
                    <div
                      className={styles.image}
                      style={{ backgroundColor: backGroundColor }}
                    ></div>
                  ) : (
                    <img className={styles.image} src={backGroundImage} />
                  )}

                  <div className={styles.title}>{levelName}</div>
                  <div className={styles.desc}>
                    {showUserName && memberName && <span>{memberName}</span>}
                    {showExpiration && (
                      <span>{`${moment(levelExpirationEnd).format(
                        'YYYY.MM.DD',
                      )}`}</span>
                    )}
                    {!!levelDesc && <span>{levelDesc}</span>}
                  </div>
                </div>
                <div
                  className={`${styles['equity-list-wrap']} ${
                    equityListAll?.length > 0 ? '' : styles['no-equity']
                  }`}
                  style={
                    listBackgroundImage
                      ? {
                          backgroundImage: `url(${listBackgroundImage})`,
                        }
                      : {}
                  }
                >
                  <div className={styles['title-wrap']}>
                    <div className={styles.title}>
                      {lvTitle}
                      {!!lvDesc && (
                        <span className={styles.desc}>{lvDesc}</span>
                      )}
                    </div>
                    <div className={styles.right}>
                      {showOrder && (
                        <Button
                          className={styles.btn}
                          onClick={() => {
                            if (!needFilterOrder) {
                              goTo('/order/orderRecord?status=')
                            } else {
                              goTo(
                                `/order/orderRecord?sourceChannel=${sourceChannel}`,
                              )
                            }
                          }}
                        >
                          {orderBtnText}
                        </Button>
                      )}
                    </div>
                  </div>
                  {equityListAll?.length > 0 && (
                    <div className={styles['list-wrap']}>
                      <div
                        className={`${styles.flex} ${
                          isExpand ? styles.expand : ''
                        }`}
                        // style={isExpand ? { height: 'auto', maxHeight: 1000 } : {}}
                      >
                        {equityListAll?.map?.((equity, index) =>
                          equity.relateType === 'group' ? (
                            <div
                              className={styles.item}
                              onClick={() => onOpenGroup(equity)}
                            >
                              <img
                                className={styles['item-image']}
                                src={
                                  equity?.imageUrl ||
                                  'https://oss-images.dragonpass.com.cn/business-saas/platform/2025-03-14_175917/%E7%A9%BA%E7%8A%B6%E6%80%81%E5%9B%BE%E6%A0%87.png'
                                }
                              />
                              <div className={styles['item-title']}>
                                {equity?.groupName || ''}
                              </div>
                              {equity.enableUseNumVisible && (
                                <div className={styles['item-desc']}>
                                  {equity?.groupDesc || ''}
                                </div>
                              )}
                            </div>
                          ) : (
                            <div
                              className={styles.item}
                              // onClick={() => goTo(equity.equityCouponUrl)}
                              onClick={() => {
                                goToEquityUrl({
                                  equityCouponCode: equity.equityCouponCode,
                                  categoryType: equity.categoryType,
                                })
                              }}
                            >
                              <img
                                className={styles['item-image']}
                                src={
                                  equity?.iconUrl ||
                                  'https://oss-images.dragonpass.com.cn/business-saas/platform/2025-03-14_175917/%E7%A9%BA%E7%8A%B6%E6%80%81%E5%9B%BE%E6%A0%87.png'
                                }
                              />
                              <div className={styles['item-title']}>
                                {equity?.relationDesc || ''}
                              </div>
                              {equity.enableUseNumVisible && (
                                <div className={styles['item-desc']}>
                                  {equity?.availableEquityNumName || ''}
                                  {equity?.equityUnitName || ''}
                                </div>
                              )}
                            </div>
                          ),
                        )}
                      </div>
                      {equityListAll.length > 8 && (
                        <div
                          className={styles.btn}
                          onClick={() => setExpand(!isExpand)}
                        >
                          <span>所有权益</span>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: isExpand ? IconCollapse : IconExpand,
                            }}
                          ></span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className={styles['content-wrap']}>
                  {/* banner */}
                  {enableSection && !!banners.length && (
                    <div className={styles['banner-wrap']}>
                      <Swiper
                        autoplay
                        pagination
                        style={{ '--swiper-theme-color': '#ffffff' }}
                      >
                        {banners?.map((banner, index) => (
                          <SwiperSlide
                            key={index}
                            pagination={{ clickable: true }}
                          >
                            <div className={styles['banner-banner']}>
                              <img
                                src={banner.activityImage}
                                onClick={
                                  banner.activityRedirectUrl
                                    ? () => goTo(banner.activityRedirectUrl)
                                    : undefined
                                }
                              />
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>
                  )}
                  {/* 推荐商品 */}
                  {enableProduct && (
                    <div className={styles['goods-wrap']}>
                      <ActivityZoneList
                        style={{
                          padding: 0,
                          '--azl-border-radius': '0px',
                          '--azl-title-border-color': style['--font-color'],
                          '--azl-title-font-size': 16,
                          '--font-color': '#ffffff',
                        }}
                        title={productTitle || ''}
                        titleClassName={styles['goods-title']}
                        dataSource={levelProducts?.map((levelProduct) => ({
                          ...levelProduct,
                          url: `/memberEquity/recommend?id=${levelProduct.id}`,
                        }))}
                        fieldNames={{
                          title: 'name',
                          imageUrl: 'imageUrl',
                          redirectUrl: 'url',
                        }}
                        squareness
                        desc={productDesc}
                      />
                    </div>
                  )}
                  {/* 专区活动 */}
                  {enableSection && (
                    <div className={styles['active-wrap']}>
                      {!!sectionTitle && (
                        <div className={styles['active-title']}>
                          {sectionTitle}
                        </div>
                      )}
                      {!!activates.length && (
                        <div className={styles['active-list']}>
                          {activates?.map((active) => (
                            <img
                              className={styles['active-item']}
                              src={active.activityImage}
                              onClick={
                                active.activityRedirectUrl
                                  ? () => goTo(active.activityRedirectUrl)
                                  : undefined
                              }
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
                {/* 底部授权&底部文案 */}
                {showBottomTip && (
                  <div className={styles['footer-wrap']}>
                    <div
                      className={`${styles['protocol-list']} ${
                        protocolList?.length > 3
                          ? styles['multi-line']
                          : styles['one-line']
                      }`}
                    >
                      {protocolList?.map((protocol) => (
                        <span
                          className={styles['protocol-item']}
                          onClick={() =>
                            setTerms({ ...protocol, visible: true })
                          }
                        >
                          {protocol.name}
                        </span>
                      ))}
                    </div>
                    <div className={styles.copyright}>{bottomTipText}</div>
                  </div>
                )}
                {/* 在线客服 */}
                {showCustomerService && customerServiceIcon && (
                  <img
                    className={styles['services-icon']}
                    src={customerServiceIcon}
                    onClick={() => onGoToService(customerServiceUrl)}
                  />
                )}

                {/* 协议弹窗 */}
                <Popup
                  showCloseButton
                  visible={terms.visible}
                  onMaskClick={() => {
                    setTerms((values) => ({ ...values, visible: false }))
                  }}
                  onClose={() => {
                    setTerms((values) => ({ ...values, visible: false }))
                  }}
                  position="right"
                  bodyStyle={{ width: '100vw' }}
                >
                  <div className={styles.termsContentWrap}>
                    <div className={styles.termsModalHeader}>{terms.name}</div>
                    <p
                      className={styles.termsModalContent}
                      dangerouslySetInnerHTML={{ __html: terms.text }}
                    ></p>
                  </div>
                </Popup>
              </div>
            </OauthAfterPageMask>
          )}
        </NoticeLayout>
      </div>
    </Layout>
  )
}

export default equityGoods
